import { render, staticRenderFns } from "./expressimport.vue?vue&type=template&id=4b2de2c8&scoped=true&"
import script from "./expressimport.vue?vue&type=script&lang=js&"
export * from "./expressimport.vue?vue&type=script&lang=js&"
import style0 from "./expressimport.vue?vue&type=style&index=0&id=4b2de2c8&lang=scss&scoped=true&"
import style1 from "./expressimport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2de2c8",
  null
  
)

export default component.exports